import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43814c47"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "share-link-selection" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "邀请链接", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tips" }, "复制链接分享给您的好友", -1))
const _hoisted_6 = { class: "share-link" }
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"share-img-selection\" data-v-43814c47><div class=\"title\" data-v-43814c47>邀请二维码</div><span class=\"tips\" data-v-43814c47>复制或保存图片分享给您的好友</span><div class=\"img\" data-v-43814c47><canvas id=\"canvas\" data-v-43814c47></canvas></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("input", {
            class: "g-input copy-selection",
            value: _ctx.shareLink,
            disabled: "",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyLink && _ctx.copyLink(...args)))
          }, null, 8, _hoisted_7),
          _createElementVNode("button", {
            class: "copy-btn link copy-selection",
            id: "copy-btn",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.copyLink && _ctx.copyLink(...args)))
          }, " 复制 ")
        ])
      ]),
      _hoisted_8
    ])
  ]))
}